import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

const PHONE = "56961018000";
const DEFAULT_MSG = "Hola, quisiera más información sobre maquinaria Great Wall.";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  const waUrl = `https://wa.me/${PHONE}?text=${encodeURIComponent(DEFAULT_MSG)}`;

  return (
    <div
      className={`fixed z-[60] bottom-5 right-5 md:bottom-7 md:right-7 transition-all duration-500 ${
        mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="whatsapp-floating"
    >
      {open && (
        <div className="mb-3 w-[280px] bg-white border-2 border-slate-950 shadow-[6px_6px_0px_0px_rgba(15,23,42,1)] animate-fade-up">
          <div className="bg-[#25D366] text-white px-4 py-3 flex items-center justify-between border-b-2 border-slate-950">
            <div>
              <div className="font-display font-black uppercase text-sm tracking-tight">WhatsApp</div>
              <div className="font-mono text-[10px] opacity-90">Respuesta en minutos</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-close-btn"
              aria-label="Cerrar"
              className="w-7 h-7 flex items-center justify-center hover:bg-white/20"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-4">
            <p className="text-sm text-slate-700 leading-relaxed">
              Hola <span className="font-bold">👋</span><br />
              Habla directo con nuestro equipo comercial Great Wall LATAM.
            </p>
            <a
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="whatsapp-start-chat"
              className="mt-3 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-display font-black uppercase tracking-wider px-4 py-3 text-xs transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> Iniciar conversación
            </a>
            <div className="text-[10px] font-mono text-slate-400 text-center mt-2">
              +569 6101 8000
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-toggle-btn"
        aria-label="Abrir WhatsApp"
        className="relative w-14 h-14 md:w-16 md:h-16 bg-[#25D366] hover:bg-[#1ebe5a] border-2 border-slate-950 shadow-[4px_4px_0px_0px_rgba(15,23,42,1)] hover:shadow-[2px_2px_0px_0px_rgba(15,23,42,1)] hover:translate-x-[2px] hover:translate-y-[2px] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none transition-all flex items-center justify-center text-white"
      >
        {!open && (
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        )}
        {open ? <X className="w-6 h-6 md:w-7 md:h-7" /> : (
          <svg viewBox="0 0 32 32" className="w-7 h-7 md:w-8 md:h-8 fill-current" aria-hidden="true">
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.426-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.945 2.722.945.36 0 2.092-.516 2.092-1.49 0-.085-.014-.171-.029-.243-.214-.557-1.605-.86-2.05-1.06zM16 26.077c-2.018 0-3.978-.546-5.696-1.577l-.402-.244-4.158 1.09 1.118-4.07-.272-.43c-1.118-1.79-1.722-3.851-1.722-5.964 0-6.187 5.07-11.257 11.272-11.257 6.187 0 11.243 5.07 11.243 11.257 0 6.187-5.056 11.195-11.243 11.195zm0-24.5C8.42 1.577 2.224 7.79 2.224 15.37c0 2.41.616 4.79 1.806 6.88L2 30l7.99-2.092a13.748 13.748 0 0 0 6.59 1.677c7.58 0 13.79-6.18 13.79-13.79C30.37 7.79 24.06 1.577 16 1.577z"/>
          </svg>
        )}
      </button>
    </div>
  );
}
